import styled from "styled-components";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const AddExistingProgramsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${COLORS.cirrus_white};
`;
